import _ from 'lodash';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses, twoPanePoses} from '../gameHelpers';

const BradColumn = posed.div({
    ...keysToSingleValue(twoPanePoses, {
        x: '-20em',
        transition: {
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, twoPanePoses), {
        x: 0,
        transition: {
            duration: 1000,
        },
    }),
});

export default BradColumn;
